import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getAuthConfig = () => {
  const token = localStorage.getItem('token');
  return { headers: { Authorization: `Bearer ${token}` } };
};

const formatValue = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'string' && value.includes('T')) {
    const date = new Date(value);
    if (!Number.isNaN(date.getTime())) return date.toLocaleString();
  }
  return String(value);
};

function EmployeeDetails() {
  const { id } = useParams();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchEmployeeDetails();
  }, [id]);

  const fetchEmployeeDetails = async () => {
    setLoading(true);
    setError('');
    try {
      let employeeData = null;
      try {
        const response = await axios.get(`${API_URL}/employees/${id}`, getAuthConfig());
        employeeData = response.data?.user || response.data?.data || response.data;
      } catch (err) {
        if (err?.response?.status !== 404 && err?.response?.status !== 405) {
          throw err;
        }
      }

      if (!employeeData) {
        const response = await axios.get(`${API_URL}/employees`, getAuthConfig());
        const employees = Array.isArray(response.data) ? response.data : [];
        employeeData = employees.find((item) => String(item.id) === String(id)) || null;
      }

      if (!employeeData) {
        setError('Employee not found.');
      }
      setEmployee(employeeData);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load employee details.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Employee Details</h1>
        <p>{employee?.name || `Employee ID: ${id}`}</p>
      </div>

      <div className="section-card">
        <div className="header-actions">
          <h2>Profile Information</h2>
          <div className="btn-group">
            <Link to={`/employees/${id}/documents`} className="btn btn-primary link-btn">
              View Documents
            </Link>
            <Link to="/employees" className="btn btn-secondary link-btn">
              Back to Employees
            </Link>
          </div>
        </div>

        {error && <div className="error-message">{error}</div>}

        {employee && (
          <div className="table-responsive">
            <table>
              <tbody>
                {Object.entries(employee).map(([key, value]) => (
                  <tr key={key}>
                    <th style={{ width: '220px', textTransform: 'capitalize' }}>
                      {key.replace(/_/g, ' ')}
                    </th>
                    <td>{formatValue(value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default EmployeeDetails;
